module.exports = __webpack_public_path__ + "img/default.94ca29db.png";